import React from 'react';
import Boat1 from 'images/Boat1.png';
import BCIF_Container from '../BCIF_Container';
import Native from './Native';
import Foreign from './Foreign';

const Png = ({ open }) => (
  <img
    style={{
      position: 'absolute',
      bottom: 0,
      right: open ? -35 : 10,
      width: open ? 287 : 287 * 0.4,
      pointerEvents: 'none',
      opacity: open ? 1 : 0.5,
      transition: 'all 2s',
      objectFit: 'contain',
    }}
    src={Boat1}
    alt=''
  />
);

const App = ({ windId }) => (
  <BCIF_Container title='使用船舶' defaultOpen={false}>
    <Native {...{ windId }} />
    <Foreign {...{ windId }} />
    <div style={{ backgroundColor: '#B9E5E8', height: 18, borderRadius: 8, marginTop: 114 }} />
    <Png />
  </BCIF_Container>
);

export default App;
